/**
 * Format a monetary amount with its currency.
 * Whole amounts render without decimals ($1, not $1.00); fractional amounts keep
 * cents ($19.99). Falls back to a plain `$` prefix if the currency code is unknown.
 */
export function formatMoney(amount: number, currency = "USD", locale = "en-US"): string {
  const hasCents = Math.round(amount * 100) % 100 !== 0
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(amount)
  } catch {
    return `$${hasCents ? amount.toFixed(2) : Math.round(amount)}`
  }
}
